import { Alert, Box, Stack, Typography } from "@mui/material";
import { HomePageItem } from "./news.interface";
import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Loading from "../ui/loading";
import { fetchImgs } from "../services/util";
import moment from "moment";

export default function HomePageItemDisplay({ value }: { value: HomePageItem }) {
  const [data, setDate] = useState<any[]>()
  function find() {
    if (value.auto) {
      const { keyword = '', channel = '', tags = '', length: limit = 2 } = value.where || {}
      axios.post('cms/newslist', { keyword, channel, tags, limit, skip: 0, status: 3 }).then(({ data }) => {
        data.data.forEach((i: any) => {
          i.newimg = Array.from(new Set([i.newimg, ...fetchImgs(i.text)].filter(i => !!i)))
        })
        setDate(data.data)
      })
    }
  }

  useEffect(find, [value])

  return <Stack spacing={2}>
    {value.auto ?
      (!!data?.length ?
        data.map((i, index) => <Stack key={index}>
          <Stack direction={"row"}>
            <Typography>{i.title}</Typography>
            {i.newimg[0] &&
              <Stack sx={{ width: 100 }}>
                <img alt="" height={50} width={100} src={i.newimg[0]} />
              </Stack>
            }
          </Stack>
          <Stack sx={{ fontSize: '.5rem' }}>{i.pubDate}</Stack>
        </Stack>)
        : (!data ? <Loading /> : <Stack><Alert color="error">无内容</Alert></Stack>)
      ) : (<Stack >
        {value.item.map((i, index) => <Stack key={index}>
          {/* 滑动 */}
          {i.imgMode === 3 && <Box sx={{ overflow: 'auto', height: `calc(266px * ${i.imgAspect})` }}>
            <Box sx={{ width: `${i.imgs.length * 100}%` }}>
              {i.imgs.map((img, imgindex) => <Box sx={{ display: 'inline-block', position: 'relative' }}>
                <img src={img} style={{ width: '266px', height: `calc(266px * ${i.imgAspect})` }} />
                <Typography sx={{ backgroundColor: '#9e9e9e80', color: '#fff', position: 'absolute', bottom: 0, width: '100%' }} variant={i.bold ? "h6" : 'body1'}>{i.title[imgindex]}</Typography>
              </Box>)}
            </Box>
          </Box>}
          {/* 并列 */}
          {i.imgMode === 2 && <Box sx={{ width: '100%', overflow: 'scroll', whiteSpace:'nowrap' }}>
            {i.imgs.map((img, imgindex) => <Box sx={{ width: 100, display: 'inline-block', overflow:'hidden', p:.5 }}>
              <img src={img} style={{width:'100%'}} />
              <Typography variant={i.bold ? "h6" : 'body1'}>{i.title[imgindex]}</Typography>
            </Box>)}
          </Box>}
          {/* 大图 */}
          {i.imgMode === 1 && <Stack >
            {i.imgs.map((img, imgindex) => <Stack>
              <img src={img} />
              <Typography variant={i.bold ? "h6" : 'body1'}>{i.title[imgindex]}</Typography>
              <Typography variant="caption">
                {moment(i.pubDate).format('YY-MM-DD')}
              </Typography>
            </Stack>)}
          </Stack>}
          {/* 小图 */}
          {i.imgMode === 0 ? <Stack flexDirection={
            i.imgs.length > 1 ? 'column' : 'row'
          }>
            <Stack>
              <Stack sx={{
                fontWeight: i.bold ? "bold" : "",
                color: i.red ? "red" : "",
                flexGrow: 1
              }}>{i.title[0]}</Stack>
              <Typography variant="caption">
                {moment(i.pubDate).format('YY-MM-DD')}
              </Typography>
            </Stack>
            <Stack direction={"row"}>
              {i.imgs.map((img, imgindex) => img ? <Stack flexGrow={1} sx={{ width: 100, m: .1 }}>
                <img alt="" height={50} width={'100%'} src={img} />
              </Stack> : null)}
            </Stack>
          </Stack> : null}
          {/* {(() => {
            const item = data?.find(x => x._id === i.links[0].id)
            if (item) {
              return <Stack>
                <Stack direction={"row"}>
                  <Typography flexGrow={1}>{item.title}</Typography>
                  {item.newimg[0] &&
                    <Stack sx={{ width: 100 }}><img alt="" height={50} width={100} src={item.newimg[0]} /></Stack>
                  }
                </Stack>
                <Stack sx={{ fontSize: '.5rem' }}>{item.pubDate}</Stack>
              </Stack>
            }
            return '未找到'
          })()} */}
        </Stack>)}
        {!value?.item.length && (<Alert color="error">无内容</Alert>)}
      </Stack>
      )
    }
  </Stack>
}